var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3841,
    cy: 22.8071,
    r: 21.7523,
    stroke: "#43377C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1261 12.4227C20.5696 12.4255 18.1187 13.3474 16.311 14.9862C14.5033 16.6251 13.4864 18.847 13.4834 21.1647C13.4803 23.0587 14.1628 24.9013 15.426 26.4099C15.426 26.4099 15.6889 26.7238 15.7319 26.7691L23.1261 34.675L30.5237 26.7651C30.5623 26.723 30.8262 26.4099 30.8262 26.4099L30.827 26.4075C32.0896 24.8996 32.7717 23.0578 32.7687 21.1647C32.7657 18.847 31.7488 16.6251 29.9411 14.9862C28.1334 13.3474 25.6825 12.4255 23.1261 12.4227ZM23.1261 24.3436C22.4326 24.3436 21.7546 24.1572 21.178 23.8079C20.6014 23.4586 20.1519 22.9621 19.8866 22.3812C19.6212 21.8004 19.5517 21.1612 19.687 20.5445C19.8223 19.9279 20.1563 19.3615 20.6467 18.9169C21.137 18.4723 21.7618 18.1695 22.442 18.0469C23.1222 17.9242 23.8272 17.9872 24.4679 18.2278C25.1086 18.4684 25.6563 18.8758 26.0415 19.3986C26.4268 19.9214 26.6325 20.536 26.6325 21.1647C26.6313 22.0075 26.2615 22.8154 25.6042 23.4114C24.9469 24.0073 24.0557 24.3426 23.1261 24.3436Z",
    fill: "#43377C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.64d292996faf854e5b9b8fcf09888d5e.svg";
export { ForwardRef as ReactComponent };